import React from 'react';
import classNames from 'classnames/bind';
import Text from '../../../../../atoms/Text';
import Stack from '../../../../../atoms/Stack';
import Icon from '../../../../../atoms/Icon';
import ActionButton from '../../common/ActionButton';

import styles from './index.module.pcss';
import { replaceWithJioCDN } from '../../../../../../utils/imageHandling';

interface GrandPrizeHeaderProps {
  platform: string;
  className?: string;
  middleImg?: string;
  header: string;
  description: string;
  onClick: () => void;
  topHeaderPrize: string;
  luckyDrawText: string;
}

const cx = classNames.bind(styles);

function GrandPrizeHeader(props: GrandPrizeHeaderProps): JSX.Element {
  const {
    platform,
    className,
    middleImg,
    header,
    description,
    onClick,
    topHeaderPrize,
    luckyDrawText
  } = props;

  const stackWidth = platform === 'app' ? [0, 100] : [10, 90];
  return (
    <div className={cx('EventHeaderContainer', className)}>
      <div className={cx('topHeaderPrize')}>
        <Stack widths={stackWidth}>
          {platform !== 'app' && (
            <Icon icon="icon-Back" iconClass={cx('backarrow')} onClick={onClick} />
          )}
          <div className={cx('grandPrizeHeading')}>
            <Text weight="bold" variant="T6" color="White">
              {topHeaderPrize}
            </Text>
            <Text weight="bold" variant="T4" color="White">
              {luckyDrawText}
            </Text>
          </div>
        </Stack>
      </div>
      <div className={cx('middleCircle', 'middleCircleGrandEvent')}>
        <img className={cx('middleImage')} alt="ballon" src={replaceWithJioCDN(middleImg)} />
      </div>
      <div className={cx('bottomHeaderPrize')}>
        <Text weight="bold" variant="T5">
          {header}
        </Text>
        <Text weight="bold" variant="T3">
          {description}
        </Text>
      </div>
    </div>
  );
}

GrandPrizeHeader.defaultProps = {
  className: '',
  middleImg: ''
};

export default GrandPrizeHeader;
